export enum ApiKeyExpiration {
  Days30,
  Days90,
  Days365,
  Never,
}
